import { forwardRef, SVGProps } from 'react'

import { TokenSymbol } from '@/domain/types/TokenSymbol'

export interface TokenIconProps extends SVGProps<SVGSVGElement> {
  token: { symbol: TokenSymbol; logo: string; isAToken?: boolean }
}

export const TokenIcon = forwardRef<SVGSVGElement, TokenIconProps>(({ token, ...rest }, ref) => {
  if (token.isAToken) {
    return <ATokenIcon logo={token.logo} {...rest} ref={ref} />
  }

  return (
    <svg ref={ref} viewBox="0 0 256 256" {...rest}>
      <image x="0" y="0" href={token.logo} width="256" height="256" />
    </svg>
  )
})
TokenIcon.displayName = 'TokenIcon'

interface ATokenIconProps extends SVGProps<SVGSVGElement> {
  logo: string
}
const ATokenIcon = forwardRef<SVGSVGElement, ATokenIconProps>(({ logo, ...rest }, ref) => {
  return (
    <svg ref={ref} viewBox="0 0 256 256" {...rest}>
      <g>
        <defs>
          {/** biome-ignore lint/correctness/useUniqueElementIds: reason missing */}
          <linearGradient id="spark-gradient">
            <stop offset="-5.71%" stopColor="#FFCD4D" />
            <stop offset="102.6%" stopColor="#FA43BD" />
          </linearGradient>
        </defs>
        <circle cx="128" cy="128" r="120" stroke="url(#spark-gradient)" fill="none" strokeWidth="15" />
        <image x="25" y="25" href={logo} width="206" height="206" />
      </g>
    </svg>
  )
})
ATokenIcon.displayName = 'ATokenIcon'
